export default __webpack_public_path__ + "static/media/work4image2.738e443f.png";